import apiClient from "../appConfig/interceptor";
import { endpoints } from "../utils/constants";

const getWorkItemState = (selectedProduct:string)=>apiClient.get(`${endpoints.pathPrefix}${selectedProduct}/workItemState`);
const saveWorkItemState=(selectedProduct:string, data: any)=>apiClient.put(`${endpoints.pathPrefix}${selectedProduct}/workItemState`, data);
const deleteWorkItemState=(selectedProduct:string, id: string)=>apiClient.delete(`${endpoints.pathPrefix}${selectedProduct}/workItemState/${id}`);

const workItemState = {
    getWorkItemState,
    saveWorkItemState,
    deleteWorkItemState
};
export default workItemState;